import { css } from '@emotion/react';
import { useDispatch } from 'react-redux';
import { RegularDropdownComponent } from '~/_shared/baseComponents/dropdown';
import { ExportReportTemplates } from '~/exportReport/template/exportReportTemplates';
import { exportReportSetTemplate } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.actionCreators';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';

const printHiddenStyle = css`
  @media print {
    display: none;
  }
`;

const templateSelectorTextStyle = css({
  margin: 0,
});

const templateDropdownStyle = css({
  width: 350,
  marginBottom: 20,
});

export const ExportReportTemplateLoaderComponent = () => {
  const reportState = useToolsStateExportReportSelector();
  const selectedTemplateId = reportState.template.id;
  const dispatch = useDispatch();

  const onSelectedTemplateChange = (templateId: string) => {
    const newTemplate = ExportReportTemplates.find(item => item.id === templateId);
    if (!newTemplate) {
      return;
    }

    dispatch(exportReportSetTemplate(newTemplate));
  };

  return (
    <div css={printHiddenStyle}>
      <p css={templateSelectorTextStyle}>Select Template</p>
      <div css={templateDropdownStyle}>
        <RegularDropdownComponent
          value={selectedTemplateId}
          onChange={onSelectedTemplateChange}
          options={ExportReportTemplates.map(item => ({ value: item.id, name: `${item.name} (${item.id})` }))}
        />
      </div>
    </div>
  );
};
